var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	21976: {
		fallback: () => (Promise.all([__webpack_require__.e(1369), __webpack_require__.e(6865), __webpack_require__.e(8146), __webpack_require__.e(3705), __webpack_require__.e(2076), __webpack_require__.e(7580)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	71369: {
		fallback: () => (Promise.all([__webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(5104), __webpack_require__.e(5573), __webpack_require__.e(845)]).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=6.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	14722: {
		fallback: () => (Promise.all([__webpack_require__.e(1369), __webpack_require__.e(316)]).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	38456: {
		fallback: () => (Promise.all([__webpack_require__.e(1369), __webpack_require__.e(6865), __webpack_require__.e(4722), __webpack_require__.e(4456)]).then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",

	},
	25652: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 52867))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	30134: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	20130: {
		fallback: () => (Promise.all([__webpack_require__.e(1369), __webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(4722), __webpack_require__.e(9935), __webpack_require__.e(4590), __webpack_require__.e(409)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 72102))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/a11y",

	},
	65418: {
		fallback: () => (Promise.all([__webpack_require__.e(1369), __webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(4722), __webpack_require__.e(7912)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 87912))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/layout",

	},
	36682: {
		fallback: () => (__webpack_require__.e(1299).then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 63680))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/bidi",

	},
	3090: {
		fallback: () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(8718)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 2814))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/coercion",

	},
	10352: {
		fallback: () => (__webpack_require__.e(1608).then(() => (() => (__webpack_require__(/*! @angular/cdk/private */ 9227))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/private",

	},
	466: {
		fallback: () => (Promise.all([__webpack_require__.e(4722), __webpack_require__.e(7699)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 17699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/platform",

	},
	4922: {
		fallback: () => (__webpack_require__.e(4879).then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 74879))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/keycodes",

	},
	51730: {
		fallback: () => (Promise.all([__webpack_require__.e(1369), __webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(4722), __webpack_require__.e(9975), __webpack_require__.e(9168), __webpack_require__.e(4939), __webpack_require__.e(8288)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 81570))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/overlay",

	},
	38018: {
		fallback: () => (__webpack_require__.e(9168).then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/portal",

	},
	58884: {
		fallback: () => (Promise.all([__webpack_require__.e(4722), __webpack_require__.e(9975), __webpack_require__.e(7860)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 79975))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/scrolling",

	},
	11656: {
		fallback: () => (__webpack_require__.e(8615).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers/private */ 98615))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/observers/private",

	},
	65716: {
		fallback: () => (Promise.all([__webpack_require__.e(1369), __webpack_require__.e(7989)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/collections */ 37989))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/collections",

	},
	79242: {
		fallback: () => (Promise.all([__webpack_require__.e(4722), __webpack_require__.e(9975), __webpack_require__.e(9168), __webpack_require__.e(4939), __webpack_require__.e(9935), __webpack_require__.e(3482)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/dialog */ 93482))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/dialog",

	},
	63662: {
		fallback: () => (__webpack_require__.e(9180).then(() => (() => (__webpack_require__(/*! @angular/cdk/accordion */ 9180))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/accordion",

	},
	26004: {
		fallback: () => (__webpack_require__.e(1920).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 39539))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/observers",

	},
	75438: {
		fallback: () => (Promise.all([__webpack_require__.e(1369), __webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(6443)]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	89811: {
		fallback: () => (Promise.all([__webpack_require__.e(4722), __webpack_require__.e(5438), __webpack_require__.e(436)]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	71050: {
		fallback: () => (__webpack_require__.e(9940).then(() => (() => (__webpack_require__(/*! @angular/cdk/text-field */ 69940))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/text-field",

	},
	32536: {
		fallback: () => (Promise.all([__webpack_require__.e(8456), __webpack_require__.e(4590), __webpack_require__.e(4315)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/stepper */ 63985))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/stepper",

	},
	47901: {
		fallback: () => (Promise.all([__webpack_require__.e(1369), __webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(1383)]).then(() => (() => (__webpack_require__(/*! @ngrx/store */ 81383))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=18.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store",

	},
	35352: {
		fallback: () => (Promise.all([__webpack_require__.e(8146), __webpack_require__.e(3705), __webpack_require__.e(9074)]).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	20232: {
		fallback: () => (Promise.all([__webpack_require__.e(1369), __webpack_require__.e(6865), __webpack_require__.e(130), __webpack_require__.e(2645), __webpack_require__.e(6682), __webpack_require__.e(5438), __webpack_require__.e(9811), __webpack_require__.e(3840), __webpack_require__.e(4546)]).then(() => (() => (__webpack_require__(/*! @angular/material/icon */ 93840))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/icon",

	},
	79148: {
		fallback: () => (Promise.all([__webpack_require__.e(1369), __webpack_require__.e(6865), __webpack_require__.e(130), __webpack_require__.e(2645), __webpack_require__.e(4722), __webpack_require__.e(5418), __webpack_require__.e(6682), __webpack_require__.e(3090), __webpack_require__.e(466), __webpack_require__.e(1656), __webpack_require__.e(8388), __webpack_require__.e(6004), __webpack_require__.e(2076), __webpack_require__.e(7914)]).then(() => (() => (__webpack_require__(/*! @angular/material/form-field */ 24950))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/form-field",

	},
	63175: {
		fallback: () => (__webpack_require__.e(4074).then(() => (() => (__webpack_require__(/*! @onesource/angular/components/account-shared */ 74074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@onesource/angular/components/account-shared",

	},
	96055: {
		fallback: () => (Promise.all([__webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(8087)]).then(() => (() => (__webpack_require__(/*! @onesource/angular/components/avatar */ 77756))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@onesource/angular/components/avatar",

	},
	24263: {
		fallback: () => (Promise.all([__webpack_require__.e(1369), __webpack_require__.e(3090), __webpack_require__.e(8456), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! @onesource/angular/components/base */ 1296))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@onesource/angular/components/base",

	},
	29473: {
		fallback: () => (Promise.all([__webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(2866), __webpack_require__.e(8232)]).then(() => (() => (__webpack_require__(/*! @onesource/angular/components/button */ 7595))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@onesource/angular/components/button",

	},
	69075: {
		fallback: () => (Promise.all([__webpack_require__.e(1236), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! @onesource/angular/components/spinner */ 71650))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@onesource/angular/components/spinner",

	},
	60236: {
		fallback: () => (Promise.all([__webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(5418), __webpack_require__.e(6682), __webpack_require__.e(3090), __webpack_require__.e(352), __webpack_require__.e(466), __webpack_require__.e(1873), __webpack_require__.e(4922), __webpack_require__.e(8018), __webpack_require__.e(8884), __webpack_require__.e(1034)]).then(() => (() => (__webpack_require__(/*! @angular/material/menu */ 31034))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/menu",

	},
	87559: {
		fallback: () => (__webpack_require__.e(4692).then(() => (() => (__webpack_require__(/*! @onesource/angular/components/tooltip */ 64692))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@onesource/angular/components/tooltip",

	},
	66355: {
		fallback: () => (__webpack_require__.e(8842).then(() => (() => (__webpack_require__(/*! @onesource/angular/components/core */ 28842))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@onesource/angular/components/core",

	},
	62866: {
		fallback: () => (Promise.all([__webpack_require__.e(130), __webpack_require__.e(5418), __webpack_require__.e(6682), __webpack_require__.e(3090), __webpack_require__.e(352), __webpack_require__.e(466), __webpack_require__.e(1873), __webpack_require__.e(4175), __webpack_require__.e(3981)]).then(() => (() => (__webpack_require__(/*! @angular/material/button */ 84175))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/button",

	},
	65609: {
		fallback: () => (Promise.all([__webpack_require__.e(5418), __webpack_require__.e(1732), __webpack_require__.e(2076), __webpack_require__.e(6036)]).then(() => (() => (__webpack_require__(/*! @onesource/angular/configuration */ 52444))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@onesource/angular/configuration",

	},
	82672: {
		fallback: () => (Promise.all([__webpack_require__.e(130), __webpack_require__.e(4722), __webpack_require__.e(5418), __webpack_require__.e(6682), __webpack_require__.e(3090), __webpack_require__.e(466), __webpack_require__.e(1656), __webpack_require__.e(8388), __webpack_require__.e(6004), __webpack_require__.e(9903)]).then(() => (() => (__webpack_require__(/*! @angular/material/input */ 95541))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/input",

	},
	74908: {
		fallback: () => (Promise.all([__webpack_require__.e(130), __webpack_require__.e(5418), __webpack_require__.e(6682), __webpack_require__.e(3090), __webpack_require__.e(352), __webpack_require__.e(466), __webpack_require__.e(1873), __webpack_require__.e(4922), __webpack_require__.e(638), __webpack_require__.e(4277), __webpack_require__.e(3613), __webpack_require__.e(9784)]).then(() => (() => (__webpack_require__(/*! @angular/material/core */ 74646))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/core",

	},
	37014: {
		fallback: () => (Promise.all([__webpack_require__.e(130), __webpack_require__.e(4722), __webpack_require__.e(5418), __webpack_require__.e(6682), __webpack_require__.e(3090), __webpack_require__.e(352), __webpack_require__.e(466), __webpack_require__.e(1873), __webpack_require__.e(4922), __webpack_require__.e(1730), __webpack_require__.e(8018), __webpack_require__.e(8884), __webpack_require__.e(1656), __webpack_require__.e(8388), __webpack_require__.e(4175), __webpack_require__.e(9710), __webpack_require__.e(4184)]).then(() => (() => (__webpack_require__(/*! @angular/material/datepicker */ 61977))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/datepicker",

	},
	92154: {
		fallback: () => (Promise.all([__webpack_require__.e(1369), __webpack_require__.e(6865), __webpack_require__.e(130), __webpack_require__.e(2645), __webpack_require__.e(5418), __webpack_require__.e(6682), __webpack_require__.e(3090), __webpack_require__.e(352), __webpack_require__.e(466), __webpack_require__.e(1873), __webpack_require__.e(4922), __webpack_require__.e(8456), __webpack_require__.e(1730), __webpack_require__.e(8884), __webpack_require__.e(1656), __webpack_require__.e(8388), __webpack_require__.e(638), __webpack_require__.e(6004), __webpack_require__.e(5716), __webpack_require__.e(4277), __webpack_require__.e(6060), __webpack_require__.e(2076), __webpack_require__.e(2139)]).then(() => (() => (__webpack_require__(/*! @angular/material/select */ 25175))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/select",

	},
	34880: {
		fallback: () => (Promise.all([__webpack_require__.e(1369), __webpack_require__.e(6865), __webpack_require__.e(130), __webpack_require__.e(2645), __webpack_require__.e(5418), __webpack_require__.e(6682), __webpack_require__.e(3090), __webpack_require__.e(352), __webpack_require__.e(466), __webpack_require__.e(1873), __webpack_require__.e(1730), __webpack_require__.e(8018), __webpack_require__.e(4175), __webpack_require__.e(2013)]).then(() => (() => (__webpack_require__(/*! @angular/material/snack-bar */ 3347))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/snack-bar",

	},
	61236: {
		fallback: () => (Promise.all([__webpack_require__.e(130), __webpack_require__.e(5418), __webpack_require__.e(6682), __webpack_require__.e(1134)]).then(() => (() => (__webpack_require__(/*! @angular/material/progress-spinner */ 41134))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/progress-spinner",

	},
	31732: {
		fallback: () => (Promise.all([__webpack_require__.e(1369), __webpack_require__.e(130), __webpack_require__.e(2645), __webpack_require__.e(6682), __webpack_require__.e(3090), __webpack_require__.e(352), __webpack_require__.e(466), __webpack_require__.e(1873), __webpack_require__.e(4922), __webpack_require__.e(8456), __webpack_require__.e(1730), __webpack_require__.e(8018), __webpack_require__.e(8884), __webpack_require__.e(1656), __webpack_require__.e(8388), __webpack_require__.e(638), __webpack_require__.e(6004), __webpack_require__.e(5716), __webpack_require__.e(4175), __webpack_require__.e(4277), __webpack_require__.e(9710), __webpack_require__.e(6060), __webpack_require__.e(4624)]).then(() => (() => (__webpack_require__(/*! @angular/material/paginator */ 24624))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/material/paginator",

	},
	28369: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @sbg/web/log */ 33798))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=5.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@sbg/web/log",

	},
	1822: {
		fallback: () => (Promise.all([__webpack_require__.e(1369), __webpack_require__.e(6865), __webpack_require__.e(2645), __webpack_require__.e(4722), __webpack_require__.e(9811), __webpack_require__.e(5104), __webpack_require__.e(5072)]).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=19.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"130": [
		20130
	],
	"232": [
		20232
	],
	"352": [
		10352
	],
	"466": [
		466
	],
	"889": [
		74908,
		37014
	],
	"1236": [
		61236
	],
	"1369": [
		71369
	],
	"1383": [
		35352
	],
	"1656": [
		11656
	],
	"1730": [
		51730
	],
	"1732": [
		31732
	],
	"1822": [
		1822
	],
	"1976": [
		21976
	],
	"2051": [
		29473,
		69075
	],
	"2154": [
		92154
	],
	"2587": [
		79242
	],
	"2672": [
		82672
	],
	"2866": [
		62866
	],
	"3090": [
		3090
	],
	"3705": [
		25652,
		30134
	],
	"4263": [
		24263
	],
	"4525": [
		60236,
		87559
	],
	"4722": [
		14722
	],
	"4880": [
		34880
	],
	"4922": [
		4922
	],
	"5418": [
		65418
	],
	"5438": [
		75438
	],
	"5716": [
		65716
	],
	"6004": [
		26004
	],
	"6622": [
		32536
	],
	"6682": [
		36682
	],
	"7237": [
		63175,
		96055
	],
	"7901": [
		47901
	],
	"8018": [
		38018
	],
	"8087": [
		66355
	],
	"8232": [
		65609
	],
	"8369": [
		28369
	],
	"8456": [
		38456
	],
	"8884": [
		58884
	],
	"9148": [
		79148
	],
	"9322": [
		63662
	],
	"9811": [
		89811
	],
	"9903": [
		71050
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}